import React from 'react';

import { ABBREVIATION_THRESHOLD } from 'helpers/abbreviateNumber';
import formatNumber, { FormatType } from 'helpers/formatNumber';
import getNumberColor from 'helpers/getNumberColor';
import {
  KPIWrapper,
  KPILabel,
  KPIValue as Value,
  TrendValue,
} from 'components/Overview/KPIs/shared.style';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';
import { HeaderWrapper } from 'components/data-visualization/Table/DropdownHead';

interface IKPIProps {
  title: string;
  value: number;
  change?: number;
  onlyShowAbbrev?: boolean;
  type?: FormatType;
}

const KPI: React.FC<IKPIProps> = (props) => {
  const { title, value, change, onlyShowAbbrev, type = 'number' } = props;
  const fullValue = !onlyShowAbbrev ? formatNumber(value, type, false) : null;
  const changeValue = formatNumber(change as number, 'trend');
  const hasTooltip = value >= ABBREVIATION_THRESHOLD;
  const abbrValue = formatNumber(value, type, true);
  const hasFullValue = fullValue !== undefined && fullValue !== null;
  const showChangeValue =
    changeValue && !(value === undefined || value === null);
  const hasColor = getNumberColor(change);

  return (
    <KPIWrapper>
      <HeaderWrapper condition={title === 'This week to date'}>
        <>
          <KPILabel>{title}</KPILabel>
          <Value>
            {hasFullValue && (
              <TippyToolTip
                enabled={hasTooltip}
                canBeCopied
                tooltipContent={fullValue || ''}
              >
                <span>{abbrValue}</span>
              </TippyToolTip>
            )}
            {!hasFullValue && abbrValue}
            {showChangeValue && (
              <TrendValue hasColor={hasColor}>{changeValue}</TrendValue>
            )}
          </Value>
        </>
      </HeaderWrapper>
    </KPIWrapper>
  );
};

export default KPI;
